import React from "react";
import { MultiSelect } from 'primereact/multiselect';
import _ from 'lodash'

const ProMultiSelect = ({value, options, onChange})=>{
  
    const locationTemplate = (option) => {
        return (
            <div className="p-field">
                <span className="roboto-font" style={{marginLeft:"4px"}}>{option.name}</span>              
            </div>
        );
    }

    const selectedLocationTemplate = (option)=>{
        if (option) {
            return (
                <div className="p-field multiselect-item-value">
                   <i className="fal fa-map-marker-alt" style={{color: '#384C7E'}}><span className="roboto-font" style={{marginLeft:"4px"}}>{option.name}</span></i>                   
                </div>
            );
        }

        return "Select Location";

    }
    
    if(! _.isEmpty(options))
        return (
            <div className="p-field p-col-12 p-md-12">
                <span className="p-float-label">
                    <MultiSelect id="multiSelect" value={value} options={options} onChange={(e) => 
                    onChange(e.value)} optionLabel="name" filter={true} 
                    filterPlaceholder="Location Name"
                    placeholder="Select Locations" 
                    itemTemplate={locationTemplate}
                     selectedItemTemplate={selectedLocationTemplate}  
                     selectedItemsLabel="{0} locations selected" display="comma"  />
                    <label htmlFor="multiSelect">Location</label>
                </span>
            </div>
        )

    return <div></div>

}

export default ProMultiSelect;